import { useDispatch } from 'react-redux';
import React, { SetStateAction } from 'react';
import { AddAlert, IPagination } from '../../../component';
import { loaded, loading } from '../../../layout/redux/layoutActions';
import { getStudiesList } from './redux/studies.controller';
import { setPagination, setStudiesList } from './redux/studies.reducer';

export const useStudiesList = () => {
  const dispatch = useDispatch();
  const getList = async (
    pageNumber = '1',
    studyTitle?: string,
    setPaginationCallback?: React.Dispatch<SetStateAction<IPagination>>
  ) => {
    dispatch(loading());
    try {
      const {
        studies,
        pagination: { total_pages, total_results, current_page },
      } = await getStudiesList(pageNumber, studyTitle);
      const pagination = {
        currentPage: current_page,
        totalPages: total_pages,
        totalResults: total_results,
      };
      dispatch(setStudiesList(studies));
      dispatch(setPagination(pagination));
      // if (setPaginationCallback) setPaginationCallback(pagination);
    } catch (error) {
      console.error(error);
      dispatch(AddAlert('warning', 'Erro ao listar estudos'));
      dispatch(setStudiesList(null));
    } finally {
      dispatch(loaded());
    }
  };
  return { getList };
};
